type CampaignThemeSource = {
  primary_color?: string | null
  secondary_color?: string | null
  button_color?: string | null
  highlight_color?: string | null
}

// eslint-disable-next-line react-refresh/only-export-components
export function resolvePublicCampaignColors(campaign: CampaignThemeSource) {
  return {
    primaryColor: campaign.primary_color || '#0f2a53',
    secondaryColor: campaign.secondary_color || '#eef4ff',
    buttonColor: campaign.button_color || '#09b158',
    highlightColor: campaign.highlight_color || '#f59e0b',
  }
}

// eslint-disable-next-line react-refresh/only-export-components
export function buildPublicCampaignThemeCss(campaign: CampaignThemeSource): string {
  const { primaryColor, secondaryColor, buttonColor, highlightColor } =
    resolvePublicCampaignColors(campaign)

  return `
    :root {
      --campaign-primary-color: ${primaryColor};
      --campaign-secondary-color: ${secondaryColor};
      --campaign-button-color: ${buttonColor};
      --campaign-highlight-color: ${highlightColor};
      --campaign-primary-color-dark: color-mix(in srgb, ${primaryColor} 82%, black);
      --campaign-secondary-color-dark: color-mix(in srgb, ${secondaryColor} 88%, black);
      --campaign-button-color-dark: color-mix(in srgb, ${buttonColor} 82%, black);
      --campaign-highlight-color-dark: color-mix(in srgb, ${highlightColor} 82%, black);
      --campaign-primary-shadow: color-mix(in srgb, ${primaryColor} 22%, transparent);
      --campaign-primary-shadow-strong: color-mix(in srgb, ${primaryColor} 28%, transparent);
      --campaign-primary-soft: color-mix(in srgb, ${primaryColor} 10%, transparent);
      --campaign-primary-border: color-mix(in srgb, ${primaryColor} 28%, transparent);
      --campaign-button-shadow: color-mix(in srgb, ${buttonColor} 26%, transparent);
      --campaign-button-border: color-mix(in srgb, ${buttonColor} 48%, white);
      --campaign-button-ring: color-mix(in srgb, ${buttonColor} 16%, transparent);
      --campaign-highlight-shadow: color-mix(in srgb, ${highlightColor} 24%, transparent);
      --campaign-highlight-border: color-mix(in srgb, ${highlightColor} 52%, white);
    }
  `
}

export function PublicCampaignThemeStyle({
  campaign,
}: {
  campaign: CampaignThemeSource
}) {
  return <style>{buildPublicCampaignThemeCss(campaign)}</style>
}
